import * as coreClient from "@azure/core-client";

export const FareSelectorRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "FareSelectorRequest",
    modelProperties: {
      customerType: {
        serializedName: "customerType",
        type: {
          name: "String"
        }
      },
      zone: {
        serializedName: "zone",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FareSelectorList: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "FareSelectorList",
    modelProperties: {
      customerTypes: {
        serializedName: "customerTypes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomerType"
            }
          }
        }
      },
      zones: {
        serializedName: "zones",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TravelArea"
            }
          }
        }
      },
      travelTimes: {
        serializedName: "travelTimes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TravelTime"
            }
          }
        }
      },
      travelMethods: {
        serializedName: "travelMethods",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TravelMethod"
            }
          }
        }
      }
    }
  }
};

export const CustomerType: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomerType",
    modelProperties: {
      typeCode: {
        serializedName: "typeCode",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      lowerAgeBand: {
        serializedName: "lowerAgeBand",
        type: {
          name: "Number"
        }
      },
      upperAgeBand: {
        serializedName: "upperAgeBand",
        type: {
          name: "Number"
        }
      },
      ageDescription: {
        serializedName: "ageDescription",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const TravelArea: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TravelArea",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      travelArea: {
        serializedName: "travelArea",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const TravelTime: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TravelTime",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      enabled: {
        serializedName: "enabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const TravelMethod: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TravelMethod",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      travelMethodName: {
        serializedName: "travelMethodName",
        type: {
          name: "String"
        }
      },
      enabled: {
        serializedName: "enabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const ApiError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "Number"
        }
      },
      shortDescription: {
        serializedName: "shortDescription",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FareRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "FareRequest",
    modelProperties: {
      customerType: {
        serializedName: "customerType",
        required: true,
        type: {
          name: "String"
        }
      },
      zone: {
        serializedName: "zone",
        required: true,
        type: {
          name: "String"
        }
      },
      travelTime: {
        serializedName: "travelTime",
        required: true,
        type: {
          name: "String"
        }
      },
      travelMethod: {
        serializedName: "travelMethod",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const TicketProduct: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TicketProduct",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "Number"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      ticketPeriodName: {
        serializedName: "ticketPeriodName",
        type: {
          name: "String"
        }
      },
      isDirectDebit: {
        serializedName: "isDirectDebit",
        type: {
          name: "Boolean"
        }
      },
      noOfDays: {
        serializedName: "noOfDays",
        type: {
          name: "Number"
        }
      },
      ticketArea: {
        serializedName: "ticketArea",
        type: {
          name: "Composite",
          className: "TravelArea"
        }
      },
      ticketTime: {
        serializedName: "ticketTime",
        type: {
          name: "Composite",
          className: "TravelTime"
        }
      },
      ticketMode: {
        serializedName: "ticketMode",
        type: {
          name: "Composite",
          className: "TravelMethod"
        }
      },
      passengerType: {
        serializedName: "passengerType",
        type: {
          name: "Composite",
          className: "CustomerType"
        }
      },
      termDates: {
        serializedName: "termDates",
        type: {
          name: "Composite",
          className: "TermDates"
        }
      },
      price: {
        serializedName: "price",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Price"
            }
          }
        }
      },
      mTicketID: {
        serializedName: "mTicketID",
        type: {
          name: "String"
        }
      },
      swiftTicketID: {
        serializedName: "SwiftTicketID",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const TermDates: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TermDates",
    modelProperties: {
      termDateFrom: {
        serializedName: "termDateFrom",
        type: {
          name: "String"
        }
      },
      termDateTo: {
        serializedName: "termDateTo",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Price: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Price",
    modelProperties: {
      dateFrom: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DDThh:mm:ss")
        },
        serializedName: "dateFrom",
        type: {
          name: "String"
        }
      },
      dateTo: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DDThh:mm:ss")
        },
        serializedName: "dateTo",
        type: {
          name: "String"
        }
      },
      price: {
        serializedName: "price",
        type: {
          name: "Number"
        }
      },
      pricePerDay: {
        serializedName: "pricePerDay",
        type: {
          name: "Number"
        }
      },
      fulfillmentMethod: {
        serializedName: "fulfillmentMethod",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      paymentMethod: {
        serializedName: "paymentMethod",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FareRequestByBundle: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "FareRequestByBundle",
    modelProperties: {
      bundleName: {
        serializedName: "bundleName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
